import React from 'react';
import Chart from "react-google-charts";
import {isMobile} from "react-device-detect";
import Accordion from 'react-bootstrap/Accordion';

class SvmTheory extends React.Component
{
	constructor(props) {
    	super(props);
		this.state =
		{
			regression_Data: [
				['Wörter', 'Klasse 1', 'Trennlinie'],
				[-0.36, -19.96, null], [0.98, 21.34, null], [0.4, 11.56, null], [-0.81, -16.34, null], [-0.89, -35.7, null], [0.44, 28.0, null], [-0.98, -56.32, null], [0.43, 17.61, null], [0.21, 21.45, null], [-0.31, -22.35, null], [-0.51, -27.47, null], [0.13, 9.3, null], [-1.54, -76.49, null], [-0.4, -28.33, null], [0.65, 30.69, null], [1.18, 60.44, null], [-0.18, -5.13, null], [1.79, 73.86, null], [1.45, 80.28, null], [-0.68, -23.81, null], [0.98, 51.79, null], [1.9, 77.47, null], [-0.44, 0.27, null], [0.31, 14.17, null], [0.76, 45.17, null], [0.78, 55.8, null], [1.95, 86.82, null], [0.33, 12.55, null], [-0.35, 2.66, null], [1.53, 68.57, null], [-0.9, -46.73, null], [-0.58, -21.92, null], [-1.05, -51.05, null], [0.38, 30.48, null], [0.01, -21.74, null], [0.46, 30.77, null], [0.14, 21.35, null], [-0.4, -13.06, null], [0.05, -15.47, null], [-1.25, -45.96, null], [1.05, 34.37, null], [0.4, 17.49, null], [-1.71, -70.34, null], [2.24, 82.21, null], [0.18, 14.03, null], [-0.21, -28.6, null], [1.23, 65.59, null], [-0.85, -35.05, null], [1.76, 72.36, null], [0.41, -0.03, null], [-0.91, -25.06, null], [-1.42, -71.99, null], [0.47, 0.73, null], [0.9, 23.32, null], [1.14, 44.45, null], [0.4, 19.45, null], [0.39, 0.19, null], [-1.73, -96.11, null], [1.47, 66.36, null], [-0.19, -5.06, null], [-0.87, -35.83, null], [0.3, 6.51, null], [1.2, 42.78, null], [-1.98, -88.17, null], [-2.55, -114.07, null], [-1.45, -61.15, null], [-0.03, -16.75, null], [0.15, -12.84, null], [1.22, 44.97, null], [1.87, 87.53, null], [2.27, 95.75, null], [-0.74, -27.11, null], [0.07, -15.29, null], [1.49, 53.69, null], [-0.67, -26.55, null], [-1.63, -76.87, null], [0.13, 16.36, null], [0.95, 29.57, null], [1.49, 45.46, null], [0.06, 10.96, null], [0.86, 38.86, null], [0.71, 26.99, null], [-0.15, -8.51, null], [-1.07, -44.92, null], [-0.1, 1.67, null], [-0.3, -25.72, null], [-0.39, -15.59, null], [0.73, 35.15, null], [0.12, 18.16, null], [-0.51, -9.63, null], [-1.23, -46.02, null], [-0.21, -2.91, null], [-0.63, -36.17, null], [0.16, 2.99, null], [0.05, -7.42, null], [-1.17, -48.44, null], [-0.36, -0.47, null], [0.36, 11.78, null], [-1.61, -52.76, null], [-1.18, -55.42, null],
				[-3.3, null, -150],
				[2.4, null, 100]
				],
			classification_Data: [
				['Wörter', 'Klasse 1', 'Trennlinie', 'Klasse 2'],
				[4.41, 4.75, null, null], [4.2, null, null, 6.52], [1.54, null, null, 7.95], [1.8, 5.5, null, null], [1.31, null, null, 6.18], [3.37, 4.52, null, null], [3, null, null, 4.5], [0.91, null, null, 6.9], [3.5, 6.92, null, null], [4.49, 4.26, null, null], [4.55, null, null, 8.14], [2.35, null, null, 6.57], [3.37, 3.29, null, null], [2.5, null, null, 6.74], [1.09, null, null, 7.01], [2.98, 3.45, null, null], [0.87, null, null, 6.88], [3.7, 4.63, null, null], [1.02, null, null, 6.85], [3, null, null, 7.07], [1.98, null, null, 6.38], [4.26, 4.95, null, null], [1.74, null, null, 7.39], [3.09, 5.12, null, null], [3.19, 4.19, null, null], [1.75, null, null, 6.01], [2.89, 4.2, null, null], [2.15, 4.44, null, null], [3.34, 4.35, null, null], [0.79, null, null, 7.6], [4.14, 4.72, null, null], [1.63, null, null, 6.98], [3.76, 6.5, null, null], [3.21, 3.46, null, null], [3.69, 4.26, null, null], [1.56, null, null, 7.14], [1.25, null, null, 5.7], [2.01, null, null, 7.45], [3.0, 4.12, null, null], [3.51, 4.51, null, null],
				[0, null, 3.8101496394720513, null], [6, null, 8.162972059622533, null]
				],
			svm_Example_Data: [
				['Wörter', 'Klasse 1', 'Trennlinie', 'Oberer Stützvektor', 'Unterer Stützvektor', 'Klasse 2'],
				[7.34, 6.23, null, null, null, null], [6.0, 7.45, null, null, null, null], [5.49, 6.27, null, null, null, null], [7.95, 6.61, null, null, null, null], [4.65, null, null, null, null, 1.37], [5.4, null, null, null, null, 2.02], [4.62, null, null, null, null, 1.82], [4.75, null, null, null, null, 1.56], [6.32, 6.55, null, null, null, null], [6.56, null, null, null, null, 1.65], [6.27, 6.56, null, null, null, null], [6.22, null, null, null, null, 1.67], [6.32, 6.85, null, null, null, null], [6.23, null, null, null, null, 0.9], [6.08, null, null, null, null, 2.12], [5.27, null, null, null, null, 2.55], [5.67, 5.74, null, null, null, null], [6.04, null, null, null, null, 2.38], [5.79, null, null, null, null, 1.32], [6.84, 5.04, null, null, null, null], [6.54, 7.39, null, null, null, null], [5.3, null, null, null, null, 2.91], [4.73, null, null, null, null, 1.35], [6.1, 6.85, null, null, null, null], [6.51, 5.85, null, null, null, null], [6.35, 5.87, null, null, null, null], [6.32, 6.99, null, null, null, null], [4.93, null, null, null, null, 1.7], [5.71, null, null, null, null, 2.89], [8.06, 6.66, null, null, null, null], [6.45, null, null, null, null, 1.24], [5.72, null, null, null, null, 2.17], [4.94, 6.53, null, null, null, null], [5.26, null, null, null, null, 1.21], [6.82, 6.4, null, null, null, null], [5.05, null, null, null, null, 1.65], [5.42, null, null, null, null, 2.22], [5.9, 6.7, null, null, null, null], [6.49, 6.81, null, null, null, null], [4.16, 5.52, null, null, null, null], [7.05, 5.37, null, null, null, null], [5.44, null, null, null, null, 2.64], [5.28, null, null, null, null, 2.46], [6.74, 6.54, null, null, null, null], [5.72, null, null, null, null, 1.56], [4.49, null, null, null, null, 2.32], [6.35, 5.69, null, null, null, null], [5.63, 6.66, null, null, null, null], [5.98, null, null, null, null, 1.05], [4.58, null, null, null, null, 2.05], [6.15, 6.84, null, null, null, null], [5.04, null, null, null, null, 2.82], [6.18, 5.95, null, null, null, null], [6.69, 6.68, null, null, null, null], [4.33, null, null, null, null, 1.75], [6.72, 5.43, null, null, null, null], [5.29, 7.36, null, null, null, null], [5.41, 6.62, null, null, null, null], [7.09, 6.49, null, null, null, null], [6.06, null, null, null, null, 1.65], [5.77, null, null, null, null, 2.19], [4.76, null, null, null, null, 1.21], [5.54, 6.49, null, null, null, null], [5.83, null, null, null, null, 0.69], [5.97, null, null, null, null, 1.56], [6.51, 5.84, null, null, null, null], [6.51, 6.71, null, null, null, null], [6.06, 6.64, null, null, null, null], [6.5, 6.7, null, null, null, null], [5.28, 6.59, null, null, null, null], [6.38, 4.82, null, null, null, null], [5.74, null, null, null, null, 1.44], [5.71, null, null, null, null, 1.42], [6.47, 6.88, null, null, null, null], [6.34, null, null, null, null, 1.95], [6.41, 6.09, null, null, null, null], [5.43, null, null, null, null, 2.36], [5.81, null, null, null, null, 1.4], [5.2, null, null, null, null, 2.03], [5.8, null, null, null, null, 0.63],
				[0, null, 5.765865378665997, null, null, null], [10, null, 2.601425823493484, null, null, null],
				[0, null, null, 6.765865378665997, null, null], [10, null, null, 3.601425823493484, null, null],
				[0, null, null, null, 4.6968, null], [10, null, null, null, 1.5324, null]

				],
			svm_overfitting_Data: [
				['Wörter', 'Klasse 1', 'Trennlinie', 'Klasse 2'],
				[2.6, null, null, 8.35], [1.76, 5.54, null, null], [2.28, 6.29, null, null], [2.67, null, null, 8.55], [0.83, 7.56, null, null], [2.01, 7.04, null, null], [1.66, null, null, 9.04], [1.5, 7.1, null, null], [1.65, 6.35, null, null], [2.27, null, null, 9.04], [2.64, null, null, 7.9], [2.76, 6.27, null, null], [2.38, 7.05, null, null], [1.81, 6.31, null, null], [1.41, 7.53, null, null], [1.31, null, null, 8.08], [1.21, null, null, 9.44], [2.38, null, null, 7.48], [1.59, 6.82, null, null], [2.47, null, null, 7.48], [1.39, 4.56, null, null], [1.13, null, null, 8.69], [2.59, null, null, 8.66], [1.67, null, null, 8.85], [2.67, 7.3, null, null], [2.87, null, null, 9.42], [1.91, null, null, 9.79], [2.66, 6.02, null, null], [1.17, null, null, 9.4], [2.95, 5.73, null, null], [2.33, 5.65, null, null], [2.15, 6.38, null, null], [1.81, null, null, 7.71], [1.31, null, null, 8.11], [2.4, 5.87, null, null], [2.86, null, null, 8.33], [1.42, null, null, 8.18], [2.1, 5.87, null, null], [1.47, 5.62, null, null], [2.54, null, null, 7.6],
				[0, null, 8, null],
				[1.41, null, 7.8, null],
				[1.95, null, 7.30, null],
				[2.38, null, 7.2, null],
				[2.5, null, 7.5, null],
				[2.67, null, 7.60, null],
				[6, null, 6.5, null]
			]
		}
	}
        // Blockierung von Updates, da dies eine statische Komponente ist
		shouldComponentUpdate()
		{
			return false;
		}

  	render()
  	{
  		return(
  		// Theoretische Einführung in SVM's(Inhalt 3. Seite)
		<div>
			<h3>SVM-Theorie</h3>
			<h4>Allgemein</h4>
			<p>
				Wie erw&auml;hnt, spielen <b>Daten</b> eine große Rolle im Bereich der maschinellen Verarbeitung. Es k&ouml;nnen jegliche Arten von Daten
				verwendet werden. Allerdings kann ein Computer ausschließlich mit Zahlen rechnen. Dies f&uuml;hrt dazu das andere Datentypen zun&auml;chst in eine
				 numerische Repr&auml;sentation umgewandelt werden m&uuml;ssen. Wie z.B. W&ouml;rter oder Bilder verarbeitet werden k&ouml;nnen ist einfachheitshalber
				 nicht Teil dieses &Uuml;berblicks. Demensprechend gehen wir davon aus, dass es sich bei Daten lediglich um Zahlen handelt. Wie bereits in dem
				 vorigen Beispiel gezeigt, geht es bei SVMs prim&auml;r um Klassifikation.
				Bei Machine Learning Problemen kann zwischen Klassifikation und Regression unterschieden werden.
				Im Bereich der Verarbeitung von Daten mit Hilfe von Machine Learning gibt es zwei Arten:
			</p>
			<p>
				Die Ausgangslage beider Varianten ist identisch - man hat Datenpunkte, die aus verschiedenen Attributen
				bestehen. Hierbei verwenden wir das Beispiel, welches zu Beginn eingef&uuml;hrt wurde. Bei diesem bestehen die Daten aus:
			</p>
				<ul>
					<li>Anzahl der Buchstaben im Satz</li>
					<li>Anzahl der Leerzeichen im Satz</li>
					<li>Anzahl der W&ouml;rter</li>
					<li>Anzahl der Verben</li>
					<li>...</li>
				</ul>
				<p>
					Es gibt zwei verschiedene Arten der Zuordnung von Datenpunken zu einer Klasse. Im &uuml;brigen wird im Bereich des maschinellen Lernens eine konkrete Zuordnung auch Label genannt.
				</p>
			{isMobile?
				<div>
					<p><b>Klassifikation</b></p>
					<div style={{ display: 'flex', maxWidth: Math.min(window.screen.width, 850) }}>
							<Chart
								width="100%"
								height={window.screen.height*0.3}
								chartType="ScatterChart"
								loader={<div>Loading Chart</div>}
								data =
								{this.state.classification_Data}
								options =
								{{
								hAxis: { title: 'Wörter', minValue: 0, maxValue: 6, viewWindow: {max: 6}},
								vAxis: { title: 'Nomen', minValue: 0, maxValue: 4 },
								interpolateNulls: true,
								pointSize: window.screen.height*0.004,
								series:
								{
								1: { lineWidth: window.screen.width*0.002, pointSize: 0 },
								2: { color: 'orange'}
								},
								legend: 'bottom'
								}}
							/>
						</div>
					<p>
							Wenn die Label <b>diskret</b> sind (= es existiert lediglich eine <b>z&auml;hlbare</b>, von Beginn feststehende,
							Anzahl von unterschiedlichen Zahlen) spricht man von Klassifikation. Im obigen Beispiel kann
							man sehen, dass einige Datenpunkte der Klasse 1 angeh&ouml;ren und andere der Klasse 2. Dies k&ouml;nnte die
							die Unterscheidung zwischen positivem (=1) und negativem (=0) Sentiment sein.
					</p>
					<p><b>Regression</b></p>
					<div style={{ display: 'flex', maxWidth: Math.min(window.screen.width, 850) }}>
						<Chart
							width="100%"
							height={window.screen.height*0.3}
							chartType="ScatterChart"
							loader={<div>Loading Chart</div>}
							data =
							{this.state.regression_Data}
							options =
							{{
							hAxis: { title: 'Wörter', minValue: 0, maxValue: 6, viewWindow: {max: 6}},
							vAxis: { title: 'Nomen', minValue: 0, viewWindow: {max: 100, min:-150}},
							interpolateNulls: true,
							pointSize: window.screen.height*0.004,
							series:
							{
							1: { lineWidth: window.screen.width*0.002, pointSize: 0 },
							2: { color: 'orange'}
							},
							legend: 'bottom'
							}}
						/>
					</div>
					<p>
							Wenn die Label <b>stetig</b> sind (= es gibt <b>unz&auml;hlbar</b> viele Zahlen) spricht man von Regression.
							Im obigen Beispiel werden alle Datenpunkte auf einen Wert gemappt, der theoretisch alle m&ouml;glichen Zahlen annehmen kann.
							Dieser k&ouml;nnte die Angabe sein, wie positiv ein Satz hinsichtlich des Sentiments ist.
					</p>
					<br/>
				</div>:
				<table>
				<tbody>
					<tr>
						<th>Klassifikation</th>
						<th>Regression</th>
					</tr>

					<tr>
						<th>
							<div style={{ display: 'flex', maxWidth: 900 }}>
								<Chart
									width={580}
									height={400}
									chartType="ScatterChart"
									loader={<div>Loading Chart</div>}
									data =
									{this.state.classification_Data}
									options =
									{{
									hAxis: { title: 'Wörter', minValue: 0, maxValue: 6 },
									vAxis: { title: 'Nomen', minValue: 0, maxValue: 4 },
									interpolateNulls: true,
									series:
									{
									1: { lineWidth: 2, pointSize: 0 },
									2: { color: 'orange'}
									}
									}}
								/>
							</div>
						</th>
						<th>
							<div style={{ display: 'flex', maxWidth: 900 }}>
								<Chart
									width={580}
									height={400}
									chartType="ScatterChart"
									loader={<div>Loading Chart</div>}
									data =
									{this.state.regression_Data}
									options =
									{{
									hAxis: { title: 'Wörter', minValue: 0, maxValue: 6 },
									vAxis: { title: 'Nomen', minValue: 0, maxValue: 4 },
									interpolateNulls: true,
									series:
									{
									1: { lineWidth: 2, pointSize: 0 },
									2: { color: 'orange'}
									}
									}}
								/>
							</div>
						</th>
					</tr>
					<tr>
						<th>
							<p>
								Wenn die Label <b>diskret</b> sind (= es existiert lediglich eine <b>z&auml;hlbare</b>, von Beginn feststehende,
								Anzahl von unterschiedlichen Zahlen) spricht man von Klassifikation. Im obigen Beispiel kann
								man sehen, dass einige Datenpunkte der Klasse 1 angeh&ouml;ren und andere der Klasse 2. Dies k&ouml;nnte die
								die Unterscheidung zwischen positivem (=1) und negativem (=0) Sentiment sein.
							</p>
						</th>
						<th>
							<p>
								Wenn die Label <b>stetig</b> sind (= es gibt <b>unz&auml;hlbar</b> viele Zahlen) spricht man von Regression.
								Im obigen Beispiel werden alle Datenpunkte auf einen Wert gemappt, der theoretisch alle m&ouml;glichen Zahlen annehmen kann.
								Dieser k&ouml;nnte die Angabe sein, wie positiv ein Satz hinsichtlich des Sentiments ist.
							</p>
						</th>
					</tr>
				</tbody>
			</table>}

			<p>
				Eine Support Vector Machine nutzt eine Regression um eine Gerade zu finden, welche zwei Klassen m&ouml;glichst gut trennt. Diese Trennung erm&ouml;glicht
				eine Klassifikation indem alle Datenpunkte auf der einen Seite der Gerade von denen auf der anderen Seite unterschieden werden k&ouml;nnen.
			</p>
				<div style={{ display: 'flex', maxWidth: isMobile? Math.min(window.screen.width, 850):850}}>
					<Chart
						width="100%"
						height={isMobile? window.screen.height*0.3: 400}
						chartType="ScatterChart"
						loader={<div>Loading Chart</div>}
						data =
						{this.state.svm_Example_Data}
						options =
						{{
						hAxis: { title: 'Wörter', minValue: 0, maxValue: 6, viewWindow: {max: 6}},
						vAxis: { title: 'Nomen', minValue: 0, maxValue: 4 },
						interpolateNulls: true,
						pointSize: isMobile? window.screen.height*0.004: 7,
						series:
						{
						0: {  color: 'blue'},
						1: { lineWidth: 2, pointSize: 0},
						2: { lineWidth: 2, pointSize: 0, lineDashStyle: [1, 1]},
						3: { lineWidth: 2, pointSize: 0, lineDashStyle: [1, 1]},
						4: { color: 'orange'}
						},
						legend: { position: isMobile? 'bottom' : 'right' }
						}}
					/>
				</div>
				<p>Um die Funktionsweise einer SVM verstehen zu k&ouml;nnen, m&uuml;ssen einige Begriffe eingef&uuml;hrt werden:</p>
				<ul>
					<li><b>St&uuml;tzvektor</b>(="Support Vector"): Jene Punkte einer Klasse, welche am n&auml;chsten an der anderen
					Klasse liegen. Auf dem Bild sind diese dadurch zu erkennen, dass die gestrichelten Geraden durch diese verlaufen.</li>
					<li><b>Spanne</b>: Die Entfernung zwischen beider Geraden, die durch die St&uuml;tzvekoren verlaufen <i>(gestrichelte Linien)</i></li>
				</ul>
				<p>
					Die SVM hat nun die Aufgabe, die <b>Spanne</b> zu maximieren. Die endg&uuml;ltige Gerade, die der Klassifizierung dienen soll,
					entsteht nun dadurch das diese zwischen der oberen und unteren gestrichelten Geraden mittig platziert wird.
				</p>
				<p>
					Neue Datenpunkte, rep&auml;sentiert durch einen Punkt innerhalb des Koordinatensystems, werden auf Grundlage der relativen Position zur
					Klassifikationsgeraden einer Klasse zugeordnet.
				</p>
				<p>Dieses Vorgehen kann allerdings auch zu <b>Problemen f&uuml;hren</b>:</p>

				<div style={{ display: 'flex', maxWidth: isMobile? Math.min(window.screen.width, 850):850 }}>
					<Chart
						width="100%"
						height={isMobile? window.screen.height*0.3: 400}
						chartType="ScatterChart"
						loader={<div>Loading Chart</div>}
						data =
						{this.state.svm_overfitting_Data}
						options =
						{{
						hAxis: { title: 'Wörter', minValue: 0, maxValue: 6, viewWindow: {max: 6}},
						vAxis: { title: 'Nomen', minValue: 0, maxValue: 4 },
						interpolateNulls: true,
						pointSize: isMobile? window.screen.height*0.004: 7,
						series:
						{
						1: { lineWidth: 2, pointSize: 0 },
						2: { color: 'orange'}
						},
						legend: { position: isMobile? 'bottom' : 'right' }
						}}
					/>
				</div>
				<p>
					Hier sei einmal das Problem des <b>Overfittings</b> symbolisiert. Im Vergleich zu den Trennlinien, die ihr bislang gesehen habt,
					ist diese an die beiden Klassen exakt angepasst. Warum soll es schlecht sein, wenn so die Trennung zwischen den Klassen sch&auml;rfer ist?
					Die Genauigkeit, auf Grundlage der Daten, mit denen das Modell trainiert wurde ist doch so h&ouml;her! Allerdings ist die Hauptaufgabe
					eines Modells auf noch nicht verf&uuml;gbaren Daten optimal zu funktionieren. Die Optimalit&auml;t der L&ouml;sung ist somit unter Umst&auml;nden nicht
					mehr gegeben. Denn man muss bedenken, dass es in der Realit&auml;t mehr als nur 2 Achsen gibt und sich das Problem des Overfittings so
					noch verschlimmern k&ouml;nnte.
				</p>
				<div className = "expert">
		      <Accordion>
		          <Accordion.Item eventKey="0">
		            <Accordion.Header>Expertenwissen: </Accordion.Header>
		            <Accordion.Body>
		              <p>In diesem Beispiel haben wir nur den einfachsten Fall der Verteilung von Datenpunkten, trennbar durch eine gerade Linie (wird auch <b>linear</b> genannt), im 2 dimensionalen Raum gezeigt.
		              Allerdings setzt das voraus, dass man einen Datenpunkt mit nur zwei Attributen darstellen kann. Jeweils ein Attribut f&uuml;r die x und y Koordinate.
		              In der Wirklichkeit ist dies allerdings nicht immer der Fall. Zum Beispiel k&ouml;nnte man zu den Attributen von der ersten Seite noch die Anzahl der Vokale hinzunehmen.
		              Hier werden die Datenpunkte mit einer Ebene getrennt. Allgemein wird im Bereich der SVMs der das Konstrukt der <b>Hyperebene</b> genutzt.
		              Vereinfacht ausgedr&uuml;ck ist dies eine M&ouml;glichkeit Datenpunkte in zwei Bereiche zu trennen.
		              Unabh&auml;ngig wie viele Attribute genutzt werden um den jeweiligen Datenpunkt zu beschreiben.</p>
		            </Accordion.Body>
		          </Accordion.Item>
          </Accordion>
        </div>
			</div>

			);
  		}


}

export default SvmTheory;
